// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Ukv3","toggleWrap":"styles_toggleWrap__2Eifc","content":"styles_content__S3LI9","selectAreaCode":"styles_selectAreaCode__37nS3"};